import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  AGENTTIC_FEDERATED_MODULES_ENABLED: agentticFederatedModulesEnabled,
  AGENTTIC_NAVIGATION_VISIBILITY: agentticNavigationVisibility,
  AGENTTIC_MODULES: agentticModules,
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  SIDEBAR_LOGO_EXPANDED: sidebarLogoExpanded,
  SIDEBAR_LOGO_EXPANDED_DARK: sidebarLogoExpandedDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
} = window.globalConfig || {};

const state = {
  agentticFederatedModulesEnabled: parseBoolean(
    agentticFederatedModulesEnabled
  ),
  agentticModules: Array.isArray(agentticModules) ? agentticModules : [],
  agentticNavigationVisibility:
    agentticNavigationVisibility &&
    typeof agentticNavigationVisibility === 'object'
      ? agentticNavigationVisibility
      : {},
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  sidebarLogoExpanded,
  sidebarLogoExpandedDark,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {
  refreshAgentticConfig: async ({ commit }, accountId) => {
    const { default: AgentticConfigAPI } = await import(
      'dashboard/api/agentticConfig'
    );
    const response = await AgentticConfigAPI.getForAccount(accountId);
    commit('SET_AGENTTIC_CONFIG', response.data || {});
  },
};

export const mutations = {
  SET_AGENTTIC_CONFIG: ($state, config) => {
    const modules = config.AGENTTIC_MODULES;
    const federatedModulesEnabled = config.AGENTTIC_FEDERATED_MODULES_ENABLED;
    const visibility = config.AGENTTIC_NAVIGATION_VISIBILITY;

    $state.agentticModules = Array.isArray(modules) ? modules : [];
    $state.agentticFederatedModulesEnabled = parseBoolean(
      federatedModulesEnabled
    );
    $state.agentticNavigationVisibility =
      visibility && typeof visibility === 'object' ? visibility : {};

    window.globalConfig = {
      ...(window.globalConfig || {}),
      AGENTTIC_FEDERATED_MODULES_ENABLED:
        $state.agentticFederatedModulesEnabled,
      AGENTTIC_MODULES: $state.agentticModules,
      AGENTTIC_NAVIGATION_VISIBILITY: $state.agentticNavigationVisibility,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
